import React from "react";

import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import CybeatsConfigListing from "./PenTestToolConfigListing";
import CybeatsCredentialsForm from "./PenTestToolCredentialsForm";

export default function PenTestToolPullAndPushView(props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={CybeatsCredentialsForm}
      PullConfigListingView={CybeatsConfigListing}
    />
  );
}